var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v(_vm._s(_vm.$language.notFound.tips))]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goToPage}},[_vm._v(_vm._s(_vm.$language.notFound.goToPage))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }